import { useMemo } from "react";
import TreeSelect, { TreeSelectProps } from "@/shared/form/tree-select";
import { useCompanyDocumentFolders } from "../model/use-company-document-folders";
import { excludeFolderSubtree } from "../model/exclude-folder-subtree";

export function CompanyDocumentFolderSelect({
  excludeFolderId,
  ...props
}: TreeSelectProps & {
  /** Папка, которую вместе с поддеревом нельзя выбрать (например, она сама при переносе). */
  excludeFolderId?: string;
}) {
  const { treeData, loading } = useCompanyDocumentFolders();

  const options = useMemo(
    () =>
      excludeFolderId
        ? excludeFolderSubtree(treeData, excludeFolderId)
        : treeData,
    [treeData, excludeFolderId],
  );

  return (
    <TreeSelect
      allowClear
      showSearch
      treeDefaultExpandAll
      treeNodeFilterProp="title"
      loading={loading}
      treeData={options}
      className="w-full"
      {...props}
    />
  );
}
